import {GET_USERS_DATA, GET_USERS_DATA_FAILURE, GET_USERS_DATA_SUCCESS} from "../constants";


const initialState = {
    userId: false,
    userNotLoggedIn: false,
    fetchedUsersData: false,
    accessToken: '',
    email: '',
    given_name: '',
    family_name: ''
};

function userReducer(state = initialState, action) {
    switch (action.type) {
        case GET_USERS_DATA:
            return {
                ...state,
                fetchedUsersData: false
            }

        case GET_USERS_DATA_SUCCESS:
            var userId = action.payload ? action.payload.sfly_uid : action.payload.uid;
            var email = action.payload ? action.payload.email : '';
            var given_name = action.payload ? action.payload.given_name : '';
            var family_name = action.payload ? action.payload.family_name : '';

            var accessToken = action.payload ? action.payload.accessToken : action.payload.accessToken;
            return {
                ...state,
                userId,
                userNotLoggedIn: false,
                fetchedUsersData: true,
                accessToken,
                email,
                given_name,
                family_name
            }

        case GET_USERS_DATA_FAILURE:
            console.log('GET_USERS_DATA_FAILURE', action.payload);
            return {
                ...state,
                userNotLoggedIn: true,
                fetchedUsersData: true
            }

        default:
            return state;
    }
}

export default userReducer;
  